/* ym-attach.js (ymattach1, 8/28) - one delegated handler for every
   YM attach button, theme-level so it survives Horizon's morphing
   page navigation (inline scripts in morphed-in content never run -
   the dead-pills lesson). Powers:
     .ym-war__pill      adds the plan to the cart - WITH the current product
                        unless the cart already holds it (ymattach2)
     .ym-bundle__addboth adds the current product + the partner
   The current variant id is read from the buy form AT CLICK TIME, so
   variant switches are honored. */
(function () {
  'use strict';

  function currentVariantId() {
    var inp = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    return inp ? parseInt(inp.value, 10) : NaN;
  }

  function addItems(items, done, fail) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) { return r.text().then(function (t) { throw new Error(t.slice(0, 120)); }); }
      done();
    }).catch(function (e) {
      console.error('[ym-attach]', e);
      fail();
    });
  }

  console.log('[ym-attach] ready');

  function sizeCollapses() {
    document.querySelectorAll('.ym-collapse').forEach(function (c) {
      var body = c.querySelector('.ym-collapse__body');
      var btn = c.querySelector('.ym-collapse__btn');
      if (!body || !btn) { return; }
      var needs = body.scrollHeight > 480;
      btn.hidden = !needs;
      if (!needs) { c.classList.remove('is-collapsed'); }
    });
  }
  if (document.readyState !== 'loading') { sizeCollapses(); }
  document.addEventListener('DOMContentLoaded', sizeCollapses);

  /* ymsys35: a <details data-ym-open-desktop> (Bundle & Save on a camera
     page, the footer brand row) ships closed and opens itself on a wide
     screen. Morphed-in pages are caught by the observer, so a product-to-
     product hop behaves like a fresh load. Never touches one the shopper
     already clicked (data-ym-touched). */
  var ymWide = window.matchMedia('(min-width: 48rem)');
  function openOnDesktop(root) {
    (root || document).querySelectorAll('details[data-ym-open-desktop]').forEach(ymOpenOne);
  }
  openOnDesktop();
  document.addEventListener('DOMContentLoaded', function () { openOnDesktop(); });
  document.addEventListener('toggle', function (ev) {
    var d = ev.target;
    if (d && d.matches && d.matches('details[data-ym-open-desktop]') && d.dataset.ymOpening !== '1') {
      d.dataset.ymTouched = '1';
    }
  }, true);
  new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      m.addedNodes.forEach(function (n) {
        if (n.nodeType !== 1) { return; }
        if (n.matches && n.matches('details[data-ym-open-desktop]')) { ymOpenOne(n); }
        if (n.querySelectorAll) { n.querySelectorAll('details[data-ym-open-desktop]').forEach(ymOpenOne); }
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
  function ymOpenOne(d) {
    if (d.dataset.ymTouched || d.open === ymWide.matches) { return; }
    d.dataset.ymOpening = '1';
    d.open = ymWide.matches;
    setTimeout(function () { delete d.dataset.ymOpening; }, 60);
  }

  document.addEventListener('click', function (ev) {
    var col = ev.target.closest('.ym-collapse__btn');
    if (col) {
      var c = col.closest('.ym-collapse');
      var collapsed = c.classList.toggle('is-collapsed');
      col.textContent = collapsed ? '+ View more' : '\u2013 View less';
      if (collapsed) { c.scrollIntoView({ block: 'start', behavior: 'smooth' }); }
      return;
    }
    var tab = ev.target.closest('.ym-tabs__btn');
    if (tab) {
      sizeCollapses();
      var wrap = tab.closest('.ym-tabs');
      wrap.querySelectorAll('.ym-tabs__btn').forEach(function (b) {
        b.classList.toggle('is-active', b === tab);
      });
      wrap.querySelectorAll('.ym-tabs__panel').forEach(function (p) {
        p.hidden = p.dataset.ympanel !== tab.dataset.ymtab;
      });
      return;
    }
    /* cartatt1: protect-it pill INSIDE the cart drawer. Adding via raw
       /cart/add.js leaves the open drawer stale, so this lane asks
       Shopify to render the drawer section in the same call and swaps
       the inner content in place - dialog stays open, items + summary
       + this very offer all recompute. Checked BEFORE .ym-war__pill so
       the PDP handler never swallows it. */
    var cpill = ev.target.closest('.ym-cartatt__pill');
    if (cpill && !cpill.disabled) {
      var cvid = parseInt(cpill.dataset.vid, 10);
      if (!cvid) { console.error('[ym-attach] cartatt pill missing vid'); return; }
      cpill.disabled = true;
      var was = cpill.textContent;
      cpill.textContent = 'adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: cvid, quantity: 1 }],
                               sections: 'cart-drawer-section' })
      }).then(function (r) {
        if (!r.ok) { return r.text().then(function (t) { throw new Error(t.slice(0, 120)); }); }
        return r.json();
      }).then(function (d) {
        var html = d && d.sections && d.sections['cart-drawer-section'];
        var cur = document.querySelector('#shopify-section-cart-drawer-section .cart-drawer__inner');
        if (html && cur) {
          var t = document.createElement('div');
          t.innerHTML = html;
          var next = t.querySelector('.cart-drawer__inner');
          if (next) { cur.replaceWith(next); return; }
        }
        window.location.href = '/cart';   /* cart PAGE or no drawer: reload-style */
      }).catch(function (e) {
        console.error('[ym-attach] cartatt', e);
        cpill.disabled = false;
        cpill.textContent = was;
      });
      return;
    }
    var pill = ev.target.closest('.ym-war__pill');
    if (pill && !pill.disabled) {
      if (pill.classList.contains('is-in')) { window.location.href = '/cart'; return; }
      var vid = parseInt(pill.dataset.vid, 10);
      if (!vid) { console.error('[ym-attach] pill missing vid'); return; }
      pill.disabled = true;
      /* ymattach2 (10/1, Robby: "when you click add warranty, should it add
         the camera too?"): yes - a plan with no gear under it is a cart
         nobody meant. The current variant rides along unless the cart
         already holds it (then the plan joins what is there). */
      var gear = currentVariantId();
      var want = [{ id: vid, quantity: 1 }];
      var go = function (withGear) {
        if (withGear && gear) { want.unshift({ id: gear, quantity: 1 }); }
        addItems(want, function () {
          pill.disabled = false;
          pill.classList.add('is-in');
          pill.innerHTML = withGear && gear ? '✓ added with the camera — view cart' : '✓ in cart — view';
        }, function () { pill.disabled = false; });
      };
      if (!gear) { go(false); return; }
      fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
        var has = (cart && cart.items || []).some(function (i) { return i.variant_id === gear; });
        go(!has);
      }).catch(function () { go(true); });
      return;
    }
    var both = ev.target.closest('.ym-bundle__addboth');
    if (both && !both.disabled) {
      var pvid = parseInt(both.dataset.vid, 10);
      var mine = currentVariantId();
      if (!pvid || !mine) { console.error('[ym-attach] addboth ids', pvid, mine); return; }
      both.disabled = true;
      both.textContent = 'adding…';
      addItems([{ id: mine, quantity: 1 }, { id: pvid, quantity: 1 }], function () {
        window.location.href = '/cart';
      }, function () {
        both.disabled = false;
        both.textContent = '+ Add both';
      });
    }
  }, true);  /* CAPTURE - Horizon components stopPropagation in bubble */

  /* notify1 (9/11) - "Text me when it's back" (snippets/ym-notify.liquid).
     Delegated submit, capture phase, same reasons as the pills. Posts to
     Darkroom's public join endpoint; the staff list texts by hand. */
  var YM_DARKROOM = 'https://darkroom-eq3f.onrender.com';
  document.addEventListener('submit', function (ev) {
    var f = ev.target;
    if (!f || !f.classList || !f.classList.contains('ym-notify__form')) return;
    ev.preventDefault(); ev.stopPropagation();
    var box = f.closest('[data-ym-notify]'), msg = f.querySelector('.ym-notify__msg'), btn = f.querySelector('.ym-notify__btn');
    var g = function (n) { var el = f.querySelector('[name="' + n + '"]'); return el ? el.value : ''; };
    var body = { sysid: box.dataset.sysid, title: box.dataset.title, handle: box.dataset.handle,
                 name: g('name'), mobile: g('mobile'), email: g('email'), website: g('website'),
                 consent: (f.querySelector('[name="consent"]') || {}).checked ? '1' : '' };
    if (!body.name || String(body.mobile || '').replace(/\D/g, '').length < 10 || !body.consent) {
      msg.hidden = false; msg.textContent = 'Name, a 10-digit mobile and the checkbox, please.'; return;
    }
    btn.disabled = true; btn.textContent = 'Saving…';
    fetch(YM_DARKROOM + '/notify/api/join', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        msg.hidden = false;
        if (j.ok) {
          f.querySelectorAll('input,button').forEach(function (x) { x.disabled = true; });
          msg.textContent = j.already ? 'You’re already on the list for this one — we’ll text you.'
            : ('Got it — you’re #' + j.position + ' on the list. We’ll text ' + body.name.split(' ')[0] + ' when it’s here.');
          btn.textContent = 'On the list';
        } else {
          msg.textContent = j.error || 'Something went wrong — text us at 330-758-7005 instead.';
          btn.disabled = false; btn.textContent = 'Try again';
        }
      })
      .catch(function () {
        msg.hidden = false; msg.textContent = 'Couldn’t reach us — text 330-758-7005 and we’ll add you by hand.';
        btn.disabled = false; btn.textContent = 'Try again';
      });
  }, true);
})();

/* filmlab3 (9/11) - the film lab order page guides ONE order at a time:
   format chips -> one form showing only what applies -> a summary with
   the single Add to cart. Free options ride as line-item properties on
   the roll line (scanner, border, TIFF, push/pull, format, prints);
   paid add-ons are their own lines, quantity = rolls, tagged "For:".
   Rules: scanner + border are 35mm-family high-res only (border needs
   Frontier); TIFF is high-res only (35mm family and 120); push/pull is
   black & white only. Nothing greys out - what doesn't apply is hidden.
   Delegated + capture phase (Horizon morphs). */
(function () {
  'use strict';
  var ROLL35 = { '35mm': 1, 'single': 1, '110': 1, 'aps': 1 };
  var SURCHARGE = { '110': '110 film', 'aps': 'APS film' };
  var LABEL = { '35mm': '35mm', '120': '120', 'single': 'Single-use camera', '110': '110', 'aps': 'APS', 'sheet': '4×5 sheet film', 'other': '' };
  function money(c) { return '$' + (c / 100).toFixed(2); }
  function q(f, sel) { return f.querySelector(sel); }
  function checked(f, name) { return f.querySelector('input[name="' + name + '"]:checked'); }
  function showFor(el, fmt) {
    var list = (el.dataset.show || '').split(/\s+/);
    var on = list.indexOf(fmt) >= 0;
    el.hidden = !on;
    return on;
  }
  function visibleChecked(f, name) {
    var c = checked(f, name);
    if (c && !c.closest('[hidden]')) { return c; }
    var cands = Array.prototype.filter.call(f.querySelectorAll('input[name="' + name + '"]'), function (i) { return !i.closest('[hidden]'); });
    var pick = cands.filter(function (i) { return i.hasAttribute('data-default'); })[0] || cands[0];
    if (pick) { pick.checked = true; }
    return pick || null;
  }
  function st_rollfmt(fmt) { return !!(ROLL35[fmt] || fmt === '120'); }
  function parse(f, k) { try { return JSON.parse(f.dataset[k] || '{}'); } catch (e) { return {}; } }

  function state(f) {
    var fmt = (checked(f, 'format') || {}).value || '35mm';
    var moreRow = q(f, '[data-more-row]'), moreBtn = q(f, '[data-more]');
    if (moreRow && moreRow.querySelector('input[name="format"]:checked')) { moreRow.hidden = false; if (moreBtn) { moreBtn.classList.add('is-open'); moreBtn.setAttribute('aria-expanded', 'true'); } }
    f.querySelectorAll('[data-show]').forEach(function (el) { showFor(el, fmt); });
    var film = fmt === 'single' ? null : visibleChecked(f, 'film');
    var svc = (fmt === 'sheet' || fmt === 'other') ? null : visibleChecked(f, 'service');
    var pr = ROLL35[fmt] ? visibleChecked(f, 'prints') : null;
    var hi = !!(svc && /high-res/i.test(svc.value));
    var bw = !!(film && /black/i.test(film.value));
    var scanner = checked(f, 'scanner'), border = q(f, '[name="border"]'), tiff = q(f, '[name="tiff"]'), push = q(f, '[name="push"]');
    var adv = {
      scanner: !!(ROLL35[fmt] && hi),
      border: !!(ROLL35[fmt] && hi && scanner && scanner.value === 'Frontier'),
      tiff: !!(hi && (ROLL35[fmt] || fmt === '120')),
      push: !!(bw && fmt !== 'single')
    };
    var any = false;
    f.querySelectorAll('[data-adv-show]').forEach(function (el) { var on = !!adv[el.dataset.advShow]; el.hidden = !on; any = any || on; });
    var det = q(f, '[data-adv]');
    if (det) { det.hidden = !any; }
    if (!adv.border && border) { border.checked = false; }
    if (!adv.tiff && tiff) { tiff.checked = false; }
    if (!adv.push && push) { push.value = ''; }
    var negs = q(f, '[data-negs]');
    var scans = !!(svc && !/develop only/i.test(svc.value));
    if (negs) { negs.hidden = !(scans && st_rollfmt(fmt)); }
    var lbl = q(f, '[data-qty-label]');
    if (lbl) { lbl.textContent = fmt === 'sheet' ? 'Sheets' : 'Rolls'; }
    return { fmt: fmt, film: film, svc: svc, pr: pr, hi: hi, bw: bw, scanner: scanner, border: border, tiff: tiff, push: push,
             rolls: Math.max(1, parseInt((q(f, '[name="rolls"]') || {}).value, 10) || 1) };
  }

  function plan(f, st) {
    var addons = parse(f, 'addons'), map = parse(f, st.fmt === '120' ? 'map120' : 'map35');
    var lines = [], items = [], unit = 0, extra = [], props = {}, base = null;
    lines.push(['Format', LABEL[st.fmt]]);
    if (st.fmt === 'other') { return { lines: lines, items: [], total: 0, ok: false }; }
    if (st.fmt === 'sheet') {
      var key = st.film && (st.film.dataset.sheet || '4×5 sheet — C-41 or black & white');
      var a = addons[key];
      if (!a) { return { lines: lines, items: [], total: 0, ok: false }; }
      lines.push(['Film', st.film ? st.film.value.replace(' (sheet)', '') : '']);
      unit = a.price;
      props = { 'Film': st.film.value.replace(' (sheet)', ''), 'Sheets': String(st.rolls) };
      if (st.push && st.push.value) { props['Push / pull'] = st.push.value; lines.push(['Push / pull', st.push.value]); }
      var sdv = checked(f, 'delivery'), sonce = 0, sset = '4×5 · ' + (st.film ? st.film.value.replace(' (sheet)', '') : '') + ' · ' + st.rolls + (st.rolls > 1 ? ' sheets' : ' sheet');
      if (sdv) { props['Delivery'] = sdv.value === 'Prepaid label' ? 'Mail-in with prepaid label' : sdv.value; }
      items.push({ id: a.id, quantity: st.rolls, properties: props });
      if (sdv && sdv.dataset.addon && addons[sdv.dataset.addon]) { sonce = addons[sdv.dataset.addon].price; items.push({ id: addons[sdv.dataset.addon].id, quantity: 1, properties: { 'For': sset } }); lines.push(['Prepaid USPS label', '+' + money(sonce)]); }
      else if (sdv) { lines.push(['Getting it to us', sdv.value]); }
      lines.push([st.rolls > 1 ? 'Sheets' : 'Sheet', String(st.rolls)]);
      return { lines: lines, items: items, total: unit * st.rolls + sonce, ok: true, unit: unit, once: sonce, set: sset };
    }
    var baseFilm = st.fmt === 'single' ? 'Single-use camera' : (st.film ? st.film.dataset.base : 'Color (C-41)');
    base = st.svc && map[baseFilm + '|' + st.svc.value];
    if (!base) { return { lines: lines, items: [], total: 0, ok: false }; }
    if (st.film) { lines.push(['Film', st.film.value]); props['Film'] = st.film.value; }
    lines.push(['Service', st.svc.value.replace(' — sleeved negatives, no scans', '')]);
    unit = base.price;
    if (st.film && st.film.dataset.addon && addons[st.film.dataset.addon]) { extra.push(st.film.dataset.addon); unit += addons[st.film.dataset.addon].price; lines.push(['E-6 development', '+' + money(addons[st.film.dataset.addon].price)]); }
    if (SURCHARGE[st.fmt] && addons[SURCHARGE[st.fmt]]) { extra.push(SURCHARGE[st.fmt]); unit += addons[SURCHARGE[st.fmt]].price; props['Format'] = LABEL[st.fmt]; lines.push([LABEL[st.fmt] + ' surcharge', '+' + money(addons[SURCHARGE[st.fmt]].price)]); }
    if (st.pr && st.pr.value && addons[st.pr.dataset.addon]) { extra.push(st.pr.dataset.addon); unit += addons[st.pr.dataset.addon].price; props['Prints'] = st.pr.value; lines.push(['Prints', st.pr.value.replace('Single set of 4×6 prints', 'one 4×6 of each').replace('Double set of 4×6 prints', 'two 4×6 of each')]); }
    if (st.hi && ROLL35[st.fmt] && st.scanner) { props['Scanner'] = st.scanner.value; lines.push(['Scanner', st.scanner.value]); }
    if (st.border && st.border.checked) { props['Border scans'] = 'Yes'; lines.push(['Border scans', 'yes']); }
    if (st.tiff && st.tiff.checked) { props['TIFF files'] = 'Yes'; lines.push(['TIFF files', 'yes']); }
    if (st.push && st.push.value) { props['Push / pull'] = st.push.value; lines.push(['Push / pull', st.push.value]); }
    var dv = checked(f, 'delivery');
    if (dv) {
      props['Delivery'] = dv.value === 'Prepaid label' ? 'Mail-in with prepaid label' : dv.value;
      if (dv.dataset.addon && addons[dv.dataset.addon]) { extra.push(dv.dataset.addon); unit += 0; lines.push(['Prepaid USPS label', '+' + money(addons[dv.dataset.addon].price)]); }
      else { lines.push(['Getting it to us', dv.value]); }
    }
    var ng = checked(f, 'negs'), ngbox = q(f, '[data-negs]');
    if (ng && ngbox && !ngbox.hidden) { props['Negatives'] = ng.value === 'Recycle' ? 'Recycle (scans only)' : 'Keep'; if (ng.value === 'Recycle') { lines.push(['Negatives', 'recycle']); } }
    lines.push([st.rolls > 1 ? 'Rolls' : 'Roll', String(st.rolls)]);
    var set = LABEL[st.fmt] + (st.film ? ' · ' + st.film.value : '') + ' · ' + st.rolls + (st.rolls > 1 ? ' rolls' : ' roll');
    items.push({ id: base.id, quantity: st.rolls, properties: props });
    var once = 0;
    extra.forEach(function (name) {
      var ad = addons[name]; if (!ad) { return; }
      if (name === 'Prepaid mail-in label') { once += ad.price; items.push({ id: ad.id, quantity: 1, properties: { 'For': set } }); }
      else { items.push({ id: ad.id, quantity: st.rolls, properties: { 'For': set } }); }
    });
    return { lines: lines, items: items, total: unit * st.rolls + once, ok: true, unit: unit, once: once, set: set };
  }

  function render(f) {
    var st = state(f), pl = plan(f, st);
    var dl = q(f, '[data-lines]'), t = q(f, '[data-total]'), btn = q(f, '.ym-lab3__add');
    if (dl) {
      dl.innerHTML = '';
      pl.lines.forEach(function (l) { var dt = document.createElement('dt'), dd = document.createElement('dd'); dt.textContent = l[0]; dd.textContent = l[1]; dl.appendChild(dt); dl.appendChild(dd); });
    }
    if (t) { t.textContent = pl.ok ? money(pl.total) + (st.rolls > 1 ? ' (' + st.rolls + ' × ' + money(pl.unit) + (pl.once ? ' + ' + money(pl.once) : '') + ')' : '') : '—'; }
    if (btn) { btn.disabled = !pl.ok; }
    f.querySelectorAll('.ym-opt').forEach(function (l) { var i = l.querySelector('input'); l.classList.toggle('is-on', !!(i && i.checked)); });
    return pl;
  }
  function renderAll() { document.querySelectorAll('form[data-ym-lab3]').forEach(render); }
  if (document.readyState !== 'loading') { renderAll(); }
  document.addEventListener('DOMContentLoaded', renderAll);
  document.addEventListener('change', function (ev) { var f = ev.target.closest && ev.target.closest('form[data-ym-lab3]'); if (f) { render(f); } }, true);
  document.addEventListener('input', function (ev) { var f = ev.target.closest && ev.target.closest('form[data-ym-lab3]'); if (f) { render(f); } }, true);

  document.addEventListener('click', function (ev) {
    var more = ev.target.closest && ev.target.closest('[data-more]');
    if (more) {
      var row = more.closest('form').querySelector('[data-more-row]');
      var open = row.hidden;
      row.hidden = !open;
      more.setAttribute('aria-expanded', open ? 'true' : 'false');
      more.classList.toggle('is-open', open);
      return;
    }
    var b = ev.target.closest && ev.target.closest('[data-another]');
    if (!b) { return; }
    var f = b.closest('form[data-ym-lab3]');
    f.reset();
    var mr = q(f, '[data-more-row]'), mb = q(f, '[data-more]');
    if (mr) { mr.hidden = true; }
    if (mb) { mb.classList.remove('is-open'); mb.setAttribute('aria-expanded', 'false'); }
    q(f, '[data-done]').hidden = true;
    q(f, '[data-summary]').hidden = false;
    render(f);
    var top = q(f, '.ym-lab3__chips');
    if (top) { top.scrollIntoView({ block: 'start', behavior: 'smooth' }); }
  }, true);

  document.addEventListener('submit', function (ev) {
    var f = ev.target;
    if (!f || !f.dataset || !('ymLab3' in f.dataset)) { return; }
    ev.preventDefault(); ev.stopPropagation();
    var pl = render(f), msg = q(f, '.ym-lab3__msg'), btn = q(f, '.ym-lab3__add');
    if (!pl.ok || !pl.items.length) { msg.hidden = false; msg.textContent = 'Pick a format and a service first.'; return; }
    btn.disabled = true; var was = btn.textContent; btn.textContent = 'Adding…'; msg.hidden = true;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: pl.items }) })
      .then(function (r) { if (!r.ok) { return r.text().then(function (t) { throw new Error(t.slice(0, 160)); }); } return r.json(); })
      .then(function () {
        btn.disabled = false; btn.textContent = was;
        q(f, '[data-summary]').hidden = true;
        var d = q(f, '[data-done]'); d.hidden = false;
        var code = ((q(f, '[name="code"]') || {}).value || '').trim();
        var txt = (pl.set || pl.lines.map(function (l) { return l[1]; }).join(' · ')) + ' — ' + money(pl.total);
        if (code) {
          /* the code rides two ways: Shopify's own /discount/<code> door
             (applies at checkout if it's a real code) and a cart note the
             lab can read even when it isn't (school / club codes) */
          fetch('/discount/' + encodeURIComponent(code) + '?redirect=/cart', { credentials: 'same-origin' }).catch(function () {});
          fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin',
                 body: JSON.stringify({ attributes: { 'Discount code': code } }) }).catch(function () {});
          txt += ' · code ' + code.toUpperCase() + ' applied at checkout';
        }
        q(f, '[data-done-text]').textContent = txt;
        var dm = q(f, '[data-done-mail]'), dvv = checked(f, 'delivery');
        if (dm) { dm.hidden = !(dvv && dvv.value !== 'Drop off'); }
        d.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      })
      .catch(function (e) {
        console.error('[ym-lab3]', e);
        btn.disabled = false; btn.textContent = was;
        msg.hidden = false; msg.textContent = 'Couldn’t add that — try again, or call 330-758-7005 and we’ll take the order by phone.';
      });
  }, true);
})();


/* navswap2 (9/28) - an off-site link in the header menu ("Prints ↗",
   "Rentals ↗") opens in a new tab. Shopify menus cannot carry a target,
   so this is delegated (it survives Horizon's morphing navigation). */
(function () {
  'use strict';
  document.addEventListener('click', function (ev) {
    var a = ev.target && ev.target.closest ? ev.target.closest('header a[href], .header a[href], #header-component a[href]') : null;
    if (!a) return;
    var url;
    try { url = new URL(a.getAttribute('href'), location.href); } catch (e) { return; }
    if (url.host && url.host !== location.host && /^https?:$/.test(url.protocol)) {
      ev.preventDefault();
      window.open(url.href, '_blank', 'noopener');
    }
  });
})();
